/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-passion-8': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" class="st0" d="M47 17.2c0-6-4.9-11-11-11h-.8C32.6 2.4 28.2 0 23.5 0c-4.7 0-9.1 2.4-11.7 6.3H11c-6 0-11 4.9-11 11 0 5.5 4.1 10.1 9.4 10.9v15.2c0 2.2 1.8 4.1 4.1 4.1h20.1c2.2 0 4.1-1.8 4.1-4.1V28.1c5.2-.8 9.3-5.3 9.3-10.9m-13.5 27h-20c-.5 0-.9-.4-.9-.9V28.1c1.5-.2 3-.8 4.3-1.6 2 1.1 4.3 1.7 6.7 1.7s4.7-.6 6.7-1.7c1.3.8 2.8 1.4 4.3 1.6v15.2c-.1.5-.6.9-1.1.9M36 25.1c-1.1 0-2.1-.2-3-.6 1.9-1.7 3.3-4 4.1-6.6.2-.8-.3-1.7-1.1-1.9-.8-.2-1.7.3-1.9 1.1-1.3 4.7-5.7 8-10.6 8-4.9 0-9.3-3.3-10.6-8-.2-.8-1.1-1.3-1.9-1.1-.8.2-1.3 1.1-1.1 1.9.7 2.6 2.2 4.9 4.1 6.6-.9.4-2 .6-3 .6-4.3 0-7.8-3.5-7.8-7.8S6.7 9.5 11 9.5c.4 0 .9 0 1.3.1.7.1 1.3-.2 1.6-.8 1.9-3.5 5.6-5.6 9.6-5.6s7.6 2.2 9.6 5.6c.3.6 1 .9 1.6.8.5-.1.9-.1 1.3-.1 4.3 0 7.8 3.5 7.8 7.8.1 4.3-3.4 7.8-7.8 7.8"/>'
  }
})
